gsap.set(".skw-product-img", {visibility:"visible"});
gsap.set(".skw-product-details", {visibility:"visible"});
gsap.set(".skw-disposable-img", {visibility:"visible"});
gsap.set(".skw-disposable-details", {visibility:"visible"});
gsap.set(".svg-arrow-left", {visibility:"visible"})
gsap.set(".svg-arrow-right", {visibility:"visible"})

const heroSwiper = new Swiper('.swiper-hero', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});


const productsSwiper = new Swiper('.swiper-products', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
      640: {
        slidesPerView: 4,
      },
    }
});

const recommendSwiper = new Swiper('.swiper-recommend', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
      640: {
        slidesPerView: 4,
      },
    }
});

gsap.from('.skw-disposable-img', {
  y: -100,
  opacity: 0,
})
gsap.from('.skw-disposable-details', {
  y: -100,
  opacity: 0,
  delay: .25,
})
gsap.from('.skw-disposable-info', {
  y: 100,
  opacity: 0,
  duration: 1,
  scrollTrigger: {
    trigger: '.skw-disposable-info',
    start: 'top 90%',
  }
})

gsap.from('.skw-product-img', {
  y: -100,
  opacity: 0,
})
gsap.from('.skw-product-details', {
  y: -100,
  opacity: 0,
  delay: .25,
})
gsap.from('.skw-product-info', {
  y: 100,
  opacity: 0,
  duration: 1,
  scrollTrigger: {
    trigger: '.skw-product-info',
    start: 'top 90%',
  }
})

gsap.from('.bk-product-info', {
  y: 100,
  opacity: 0,
  duration: 1,
  scrollTrigger: {
    trigger: '.bk-product-info',
    start: 'top 90%'
  }
})

window.addEventListener("load", () => {
  ScrollTrigger.create({
    trigger: '#freebase-main-container',
    start: 'top 7%',
    pin: '.doodle-btns-freebase',
    pinSpacing: false,
    invalidateOnRefresh: true,
  });

  ScrollTrigger.create({
    trigger: '#saltnic-main-container',
    start: 'top 7%',
    pin: '.doodle-btns-saltnic',
    pinSpacing: false,
    invalidateOnRefresh: true,
  });

  ScrollTrigger.refresh();
});


gsap.utils.toArray(".arrow").forEach(effect => {
    gsap.to(effect,{
        scrollTrigger:{
            trigger:effect,
            start:"top 90%",
            onEnter: () => effect.classList.add('active-arrows'),
        }
    }) 
});


// Select all elements with the class "cannabis-accordion"
const coaAccordionBtns = document.querySelectorAll(".cert-cannabis-accordion");

if (coaAccordionBtns.length > 0) {
  coaAccordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      const isOpen = this.classList.toggle("is-open");
      this.setAttribute("aria-expanded", isOpen);

      let content = this.nextElementSibling;

      if (isOpen) {
        // Dynamically set maxHeight based on content size
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = null;
      }
    };

    // Adjust maxHeight on window resize to ensure proper behavior on screen rotation or resizing
    window.addEventListener("resize", () => {
      const isOpen = accordion.classList.contains("is-open");
      let content = accordion.nextElementSibling;

      if (isOpen) {
        // Recalculate maxHeight based on new screen dimensions
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
}

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    ScrollTrigger.refresh(true); // Force re-calculation
  }
});

ScrollTrigger.refresh();


// let resizeTimer;

// function scrollTriggerResize() {
//     return window.location.pathname === "/pages/freebase" || window.location.pathname === "/pages/salt-nicotine";
// }

// if (scrollTriggerResize()) {
//     window.addEventListener("resize", () => {
//         clearTimeout(resizeTimer);
        
//         resizeTimer = setTimeout(() => {
//             console.log("Refreshing ScrollTrigger...");
//             ScrollTrigger.refresh();

//             // Reload the window only when necessary (e.g., when switching breakpoints)
//             location.reload();
//         }, 250); // Adjust delay to prevent excessive refresh/reload
//     });
// }





